import React, { forwardRef, useRef, useImperativeHandle, useEffect, useState } from "react";

import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import styles from "./AuditNotesForm.module.sass";
import {
    SovosBox,
    SovosTypography,
    SovosTextField,
    SovosIconButton,
    SovosSelect,
    SovosMenuItem,
} from "mosaic-react";
import { Send } from "mosaic-react-icons";

import { datetime } from "../../../utils";
let origin;
let showAuditNoteHistory;
let entity;

const snakeCaseToPascalCase = (str) => {
    const camelize = str.replace(/_\w/g, (m) => m[1].toUpperCase());
    return camelize.substring(0, 1).toUpperCase() + camelize.substring(1);
};

const AuditNotesForm = (props, ref) => {
    const { data, status, onChange, onSave } = props;

    const formRef = useRef();
    const { auditNotesHistory, findingId } = data || {};

    const { i18n, params, user } = useGlobalValue();

    const { name } = user || {};

    const [auditStatus, setAuditStatus] = useState("");
    const [auditMessage, setAuditMessage] = useState("");

    const { projectId, importId, fiscalYear, modulePrefix, entities: allEntities } = params;

    const entities = (allEntities || "").split("/");
    const entityPairs = (entities || []).reduce((pairs, current) => {
        if (!pairs[pairs.length - 1] || pairs[pairs.length - 1].length === 2) {
            pairs.push([]);
        }
        if (pairs[pairs.length - 1]) {
            pairs[pairs.length - 1].push(current);
        }
        return pairs;
    }, []);

    const entityIndex = entities.length % 2 === 0 ? entityPairs.length - 1 : entityPairs.length - 2;

    const entityName = (entityPairs[entityIndex] || [])[0];
    const entityId = (entityPairs[entityIndex] || [])[1];

    entity = entityName;

    const handleChange = (e, prop, value) => {
        onChange &&
            onChange({
                originalEvent: e,
                target: {
                    value: {
                        data: {
                            ...data,
                            [prop]: value,
                        },
                    },
                },
            });
    };

    const refs = (auditNotesHistory || []).reduce((acc, value) => {
        acc[value.id] = React.createRef();
        return acc;
    }, {});

    const scrollToBottomList = (id) =>
        refs[id].current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });

    useEffect(() => {
        if (auditNotesHistory && auditNotesHistory.length && refs && showAuditNoteHistory) {
            scrollToBottomList(auditNotesHistory[auditNotesHistory.length - 1]["id"]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auditNotesHistory]);

    useImperativeHandle(ref, () => ({
        submit: () => {
            formRef.current.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
        },
    }));

    return status !== "loading" ? (
        <form className={styles["form-group-content"]} ref={formRef}>
            <div className={styles["group-content"]}>
                <div className={styles["audit-note-container-border"]}>
                    {showAuditNoteHistory && auditNotesHistory && auditNotesHistory.length
                        ? auditNotesHistory.map((auditNotes) => {
                              const { auditNote, username, id, auditStatus, createdAt } =
                                  auditNotes;
                              return (
                                  <>
                                      <SovosBox
                                          className={
                                              isAuditNoteUserWriter(name, username)
                                                  ? `${styles["container"]} ${styles["own-user"]}`
                                                  : `${styles["own-container"]} ${styles["other-user"]}`
                                          }
                                          key={`${username}_${id}`}
                                          ref={refs[id]}
                                          sx={{
                                              marginBottom: 2,
                                              padding: 1,
                                              border: "1px solid #ddd",
                                              borderRadius: 1,
                                          }}
                                      >
                                          <SovosBox
                                              sx={{
                                                  display: "inline-flex",
                                                  padding: "16px",
                                                  flexDirection: "column",
                                                  alignItems: "flex-start",
                                                  gap: "8px",
                                                  width: "100%",
                                              }}
                                          >
                                              <SovosBox
                                                  sx={{
                                                      display: "flex",
                                                      flexDirection: "row",
                                                      flexWrap: "nowrap",
                                                      justifyContent: "space-between",
                                                      alignItems: "stretch",
                                                      alignContent: "stretch",
                                                      width: "100%",
                                                  }}
                                              >
                                                  <SovosBox sx={{ flex: "1 1 auto" }}>
                                                      <SovosTypography
                                                          variant="body2"
                                                          component="p"
                                                      >
                                                          <span style={{ fontWeight: "bold" }}>
                                                              {username}
                                                          </span>{" "}
                                                          {i18n`mark_it_as` + " "}
                                                          <span
                                                              style={{
                                                                  color:
                                                                      auditStatus === "Fraud"
                                                                          ? "red"
                                                                          : auditStatus ===
                                                                              "Compliant"
                                                                            ? "green"
                                                                            : "#FFB400",
                                                                  fontFamily: "Inter",
                                                                  fontSize: 14,
                                                                  fontWeight: 700,
                                                                  lineHeight: "20px",
                                                                  letterSpacing: "0.2px",
                                                                  textAlign: "left",
                                                              }}
                                                          >
                                                              {auditStatus}
                                                          </span>
                                                      </SovosTypography>
                                                  </SovosBox>
                                                  <SovosTypography
                                                      variant="caption"
                                                      display="block"
                                                      gutterBottom
                                                  >
                                                      {datetime(createdAt, "mmm dd h:MMtt")}
                                                  </SovosTypography>
                                              </SovosBox>
                                              <SovosTypography
                                                  variant="body2"
                                                  component="p"
                                                  sx={{
                                                      width: "100%",
                                                      wordWrap: "break-word",
                                                  }}
                                              >
                                                  {auditNote}
                                              </SovosTypography>
                                          </SovosBox>
                                      </SovosBox>

                                      <div key={`${username}_${id}`} ref={refs[id]}></div>
                                  </>
                              );
                          })
                        : null}
                </div>

                <SovosBox
                    className={styles["chat-note"]}
                    sx={{
                        padding: 2,
                        border: "1px solid #ddd",
                        borderRadius: 1,
                        backgroundColor: "#fff",
                    }}
                >
                    <SovosTypography variant="subtitle1" component="p" sx={{ marginBottom: 1 }}>
                        {i18n`leave_a_note`}
                    </SovosTypography>
                    <SovosSelect
                        fullWidth
                        defaultValue=""
                        label={i18n`audit_status_as_placeholder`}
                        style={{
                            backgroundColor: "#7390CF1A",
                            color: "#545E75",
                            minHeight: "0px",
                            marginBottom: "16px",
                        }}
                        onChange={(e) => {
                            setAuditStatus(e.target.value);
                            handleChange(e, "AuditStatus", e.target.value);
                        }}
                        value={auditStatus}
                        required
                    >
                        <SovosMenuItem value="Fraud">{i18n`fraud`}</SovosMenuItem>
                        <SovosMenuItem value="To be validated">{i18n`to-be-validated`}</SovosMenuItem>
                        <SovosMenuItem value="Compliant">{i18n`compliant`}</SovosMenuItem>
                    </SovosSelect>
                    <SovosBox
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            borderRadius: "0px",
                            border: "1px solid var(--utilities-Divider, #DBE0E5)",
                            background: "var(--Utilities-White, #FFF)",
                            paddingRight: "8px",
                        }}
                    >
                        <SovosTextField
                            id="auditNote"
                            placeholder={i18n`type_to_leave_audit_notes_here`}
                            multiline
                            variant="outlined"
                            fullWidth
                            required
                            value={auditMessage}
                            onChange={(e) => {
                                handleChange(e, "AuditNote", e.target.value);
                                setAuditMessage(e.target.value);
                            }}
                            sx={{
                                padding: "24px 0px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "none",
                                "& fieldset": { border: "none" },
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: "#ddd",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "#ddd",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#ddd",
                                    },
                                },
                            }}
                        />
                        <SovosIconButton
                            sx={{ "&:hover": { color: "grey" } }}
                            tooltipText={i18n`new audit note`}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (formRef.current.checkValidity()) {
                                    data["projectId"] = projectId;
                                    data["sourceId"] = findingId;
                                    data["importId"] = importId;
                                    data["fiscalYear"] = fiscalYear;
                                    data["Origin"] = origin;
                                    data["modulePrefix"] = modulePrefix;
                                    data["EntityName"] = snakeCaseToPascalCase(entityName || "");
                                    data["RowID"] = entityId;
                                    setAuditStatus("");
                                    setAuditMessage("");
                                    onSave && onSave();
                                } else {
                                    formRef.current.reportValidity();
                                }
                            }}
                        >
                            <Send />
                        </SovosIconButton>
                    </SovosBox>
                </SovosBox>
            </div>
        </form>
    ) : null;
};

const AuditNotesFormRef = forwardRef(AuditNotesForm);

AuditNotesFormRef.queries = (args) => {
    origin = args.origin;
    showAuditNoteHistory = args.showAuditNoteHistory;
    return [
        {
            resource: `nc_audit_note_finding_history`,
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                importId: args.importId,
                findingId: args.findingId,
                origin: args.origin,
                entityId: args.entityId,
                entity: entity,
            },
            body: `auditNotesHistory{auditNote, userID, id, auditStatus, createdAt, username}, findingId`,
        },
        {
            resource: `nc_audit_note_status_types`,
            body: `auditStatusTypes{ id, name }`,
        },
    ];
};

AuditNotesFormRef.dataMapper = ["data", "auditNoteStatusTypes"];

export default AuditNotesFormRef;

function isAuditNoteUserWriter(username, auditNoteUsername) {
    return auditNoteUsername === username;
}
